import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins';
import {VMoney} from 'v-money';
import './extensions/string.ext';

Vue.directive('money', VMoney);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
